import { render, staticRenderFns } from "./ExibirStatus.vue?vue&type=template&id=05e32c59&scoped=true&"
import script from "./ExibirStatus.vue?vue&type=script&lang=js&"
export * from "./ExibirStatus.vue?vue&type=script&lang=js&"
import style0 from "./ExibirStatus.vue?vue&type=style&index=0&id=05e32c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e32c59",
  null
  
)

export default component.exports